function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1 106.5H161",
  stroke: "url(#paint0_linear)",
  strokeWidth: 2,
  strokeLinecap: "square"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M1 57.5H161",
  stroke: "url(#paint1_linear)",
  strokeWidth: 2,
  strokeLinecap: "square"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M105.5 161L105.5 0.999998",
  stroke: "url(#paint2_linear)",
  strokeWidth: 2,
  strokeLinecap: "square"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M55.5 161L55.5 0.999998",
  stroke: "url(#paint3_linear)",
  strokeWidth: 2,
  strokeLinecap: "square"
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M117.595 109.426C115.737 109.426 114.219 110.953 114.219 112.823V108.858C114.219 106.989 112.701 105.461 110.843 105.461C108.985 105.461 107.467 106.989 107.467 108.858V106.44C107.467 104.571 105.949 103.044 104.091 103.044C102.232 103.044 100.715 104.571 100.715 106.44V96.3967C100.715 94.527 99.197 93 97.3387 93C95.4805 93 93.9627 94.527 93.9627 96.3967V120.683L89.9737 116.67C88.6116 115.299 86.3836 115.299 85.0215 116.67C83.6595 118.04 83.6595 120.282 85.0215 121.652L96.0641 132.763C98.6326 135.954 102.573 138 106.98 138C114.491 138 120.63 132.078 120.981 124.638H121V112.813C120.971 110.963 119.453 109.426 117.595 109.426Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M117.595 109.426C115.737 109.426 114.219 110.953 114.219 112.823V108.858C114.219 106.989 112.701 105.461 110.843 105.461C108.985 105.461 107.467 106.989 107.467 108.858V106.44C107.467 104.571 105.949 103.044 104.091 103.044C102.232 103.044 100.715 104.571 100.715 106.44V96.3967C100.715 94.527 99.197 93 97.3387 93C95.4805 93 93.9627 94.527 93.9627 96.3967V120.683L89.9737 116.67C88.6116 115.299 86.3836 115.299 85.0215 116.67C83.6595 118.04 83.6595 120.282 85.0215 121.652L96.0641 132.763C98.6326 135.954 102.573 138 106.98 138C114.491 138 120.63 132.078 120.981 124.638H121V112.813C120.971 110.963 119.453 109.426 117.595 109.426Z",
  stroke: "#D8D8D8"
}));

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M71.9753 84.968L76.3753 80.712C76.5033 80.584 76.6366 80.4507 76.7753 80.312C76.9139 80.1627 77.0366 80.008 77.1433 79.848C77.2606 79.688 77.3566 79.5227 77.4313 79.352C77.5059 79.1707 77.5433 78.984 77.5433 78.792C77.5433 78.5573 77.4953 78.3493 77.3993 78.168C77.3139 77.9867 77.1966 77.832 77.0473 77.704C76.8979 77.576 76.7219 77.48 76.5193 77.416C76.3273 77.3413 76.1193 77.304 75.8953 77.304C75.4153 77.304 75.0206 77.4427 74.7113 77.72C74.4019 77.9973 74.2153 78.3707 74.1513 78.84L72.1353 78.68C72.1779 78.1573 72.3006 77.6987 72.5033 77.304C72.7166 76.8987 72.9886 76.5627 73.3193 76.296C73.6499 76.0293 74.0339 75.8267 74.4713 75.688C74.9086 75.5493 75.3833 75.48 75.8953 75.48C76.4073 75.48 76.8819 75.5493 77.3193 75.688C77.7673 75.816 78.1566 76.0133 78.4873 76.28C78.8179 76.536 79.0793 76.8667 79.2713 77.272C79.4633 77.6773 79.5593 78.152 79.5593 78.696C79.5593 79.4107 79.3939 80.0293 79.0633 80.552C78.7433 81.064 78.3273 81.5547 77.8153 82.024L74.3113 85.272H79.5593V87H71.9753V84.968ZM81.14 81.336C81.14 80.44 81.2093 79.6773 81.348 79.048C81.4973 78.408 81.6893 77.8747 81.924 77.448C82.1587 77.0107 82.42 76.664 82.708 76.408C83.0067 76.1413 83.3053 75.944 83.604 75.816C83.9133 75.6773 84.2067 75.5867 84.484 75.544C84.772 75.5013 85.0227 75.48 85.236 75.48C85.4493 75.48 85.6947 75.5013 85.972 75.544C86.26 75.5867 86.5533 75.6773 86.852 75.816C87.1613 75.944 87.46 76.1413 87.748 76.408C88.0467 76.664 88.3133 77.0107 88.548 77.448C88.7827 77.8747 88.9693 78.408 89.108 79.048C89.2573 79.6773 89.332 80.44 89.332 81.336C89.332 82.232 89.2573 83 89.108 83.64C88.9693 84.2693 88.7827 84.8027 88.548 85.24C88.3133 85.6667 88.0467 86.0133 87.748 86.28C87.46 86.536 87.1613 86.7333 86.852 86.872C86.5533 87 86.26 87.0853 85.972 87.128C85.6947 87.1707 85.4493 87.192 85.236 87.192C85.0227 87.192 84.772 87.1707 84.484 87.128C84.2067 87.0853 83.9133 87 83.604 86.872C83.3053 86.7333 83.0067 86.536 82.708 86.28C82.42 86.0133 82.1587 85.6667 81.924 85.24C81.6893 84.8027 81.4973 84.2693 81.348 83.64C81.2093 83 81.14 82.232 81.14 81.336ZM83.06 81.336C83.06 81.688 83.0813 82.0987 83.124 82.568C83.1773 83.0267 83.2787 83.464 83.428 83.88C83.5773 84.296 83.796 84.648 84.084 84.936C84.372 85.224 84.756 85.368 85.236 85.368C85.716 85.368 86.1 85.224 86.388 84.936C86.676 84.648 86.8947 84.296 87.044 83.88C87.1933 83.464 87.2893 83.0267 87.332 82.568C87.3853 82.0987 87.412 81.688 87.412 81.336C87.412 80.984 87.3853 80.5787 87.332 80.12C87.2893 79.6507 87.1933 79.208 87.044 78.792C86.8947 78.376 86.676 78.024 86.388 77.736C86.1 77.448 85.716 77.304 85.236 77.304C84.756 77.304 84.372 77.448 84.084 77.736C83.796 78.024 83.5773 78.376 83.428 78.792C83.2787 79.208 83.1773 79.6507 83.124 80.12C83.0813 80.5787 83.06 80.984 83.06 81.336Z",
  fill: "#FF3A3A"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 90,
  cy: 73,
  r: 3,
  fill: "#FF3A3A"
});

var _ref9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d",
  x: 67.5,
  y: 82.5,
  width: 62.0001,
  height: 70,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -4,
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.877972 0 0 0 0 0.891052 0 0 0 0 0.943373 0 0 0 0.68181 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 161,
  y1: 106,
  x2: 1.00016,
  y2: 107.025,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E6E6E6",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.512413,
  stopColor: "#E6E6E6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E6E6E6",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 161,
  y1: 56.9999,
  x2: 1.00016,
  y2: 58.0254,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E6E6E6",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.512413,
  stopColor: "#E6E6E6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E6E6E6",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 105,
  y1: 1,
  x2: 106.025,
  y2: 161,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E6E6E6",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.512413,
  stopColor: "#E6E6E6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E6E6E6",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 54.9999,
  y1: 1,
  x2: 56.0254,
  y2: 161,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E6E6E6",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.512413,
  stopColor: "#E6E6E6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E6E6E6",
  stopOpacity: 0
})));

var SvgHint = function SvgHint(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 162,
    viewBox: "0 0 162 162",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHint, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hint.95e15884.svg";
export { ForwardRef as ReactComponent };